export type ContactFormState = {
  errors: { [string]: ?string },
  type: string,
  model: string,
  title: string,
  firstName: string,
  lastName: string,
  street: string,
  houseNumber: string,
  postalCode: string,
  city: string,
  country: string,
  dealer: string,
  telephone: string,
  email: string,
  termsAccepted: boolean,
  showTerms: boolean,
  emailOptIn: boolean,
  telephoneOptIn: boolean,
  smsOptIn: boolean,
  promotionalTermsAccepted: boolean,
  showPromotionalTerms: boolean,
  sent: boolean,
  market: string,
  campaign: string,
  campaignType: string,
  language: string,
  assignToDealer: boolean,
  organisation: string,
  loading: boolean,
};

export const CONTACT_TYPES = [
  'ANGEBOTSANFRAGE',
  'WERKSTATTTERMIN',
  'PROBEFAHRT',
  'BERATUNGSTERMIN',
  'KONFIGURIEREN',
  'SERVICEANFRAGE',
  'SERVICEKONTAKT',
  'ONLINE_SERVICE_BOOKING',
  'NEWSLETTER',
  'USED_CAR_EVALUATION',
  'USED_CAR_EVALUATION_DISABLED'
];

export const MODAL_TYPES = {
  REQUEST_FOR_PROPOSAL: { name: 'REQUEST_FOR_PROPOSAL', contactType: 'ANGEBOTSANFRAGE' },
  SERVICE_APPOINTMENT: { name: 'SERVICE_APPOINTMENT', contactType: 'WERKSTATTTERMIN' },
  TEST_DRIVE: { name: 'TEST_DRIVE', contactType: 'PROBEFAHRT' },
  NEWSLETTER: { name: 'NEWSLETTER', contactType: 'NEWSLETTER' },
  REQUEST_FOR_CONSULTATION: { name: 'REQUEST_FOR_CONSULTATION', contactType: 'BERATUNGSTERMIN' },
  REQUEST_FOR_CONSULTATION_FK: {
    name: 'REQUEST_FOR_CONSULTATION_FK',
    contactType: 'BERATUNGSTERMIN',
  },
  REQUEST_FOR_CONSULTATION_WS: {
    name: 'REQUEST_FOR_CONSULTATION_WS',
    contactType: 'BERATUNGSTERMIN',
  },
  CAR_CONFIGURATOR: { name: 'CAR_CONFIGURATOR', contactType: 'KONFIGURIEREN' },
  TOPCARS: { name: 'TOPCARS', contactType: 'TOPCARS' },
  ONLINE_SERVICE_BOOKING: { name: 'ONLINE_SERVICE_BOOKING', contactType: 'ONLINE_SERVICE_BOOKING' },
  SERVICE_BOOKING_FALLBACK: {
    name: 'SERVICE_BOOKING_FALLBACK',
    contactType: 'SERVICE_BOOKING_FALLBACK',
  },
  SERVICE_REQUEST: { name: 'SERVICE_REQUEST', contactType: 'SERVICEANFRAGE' },
  SERVICE_CONTACT: { name: 'SERVICE_CONTACT', contactType: 'SERVICEKONTAKT' },
  HEADER_WERKSTATTTERMIN: { name: 'HEADER_WERKSTATTTERMIN', contactType: 'HEADER_WERKSTATTTERMIN' },
  SERVICE_OSR: { name: 'SERVICE_OSR', contactType: 'SERVICE_OSR' },
  REQUEST_FOR_CONSULTATION_OSBFB: {
    name: 'REQUEST_FOR_CONSULTATION_OSBFB',
    contactType: 'BERATUNGSTERMIN',
  },
  USED_CAR_EVALUATION: { name: 'USED_CAR_EVALUATION', contactType: 'GEBRAUCHTWAGENBEWERTUNG' },
  USED_CAR_EVALUATION_DISABLED: { name: 'USED_CAR_EVALUATION_DISABLED', contactType: 'GEBRAUCHTWAGENBEWERTUNG' },
};

export const FORM_SALUTATIONS = [
  { value: 'Mr', label: 'Herr' },
  { value: 'Mrs', label: 'Frau' },
];
